import "@hotwired/turbo-rails";
import "@rails/actiontext";
import Lexxy from "./utils/lexxy";
import Trix from "./utils/trix";

import "./controllers";
import "./elements";

export default { Lexxy, Trix };
